import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { AuthService } from '@http/auth.service';

@Component({
    selector: 'app-header-content',
    templateUrl: './header-content.component.html',
    styleUrls: ['./header-content.component.scss'],
    host: { ngSkipHydration: 'true' },
    standalone: false
})
export class HeaderContentComponent {

  constructor(public authService: AuthService,
              private router: Router,
              private localize: LocalizeRouterService) {
  }

  /**
   * Clears the session, then goes to the login page. Previously this was a plain
   * routerLink to /member/login and the session was only cleared because
   * LoginComponent.ngOnInit() happens to call logout() — so the menu entry silently
   * did nothing whenever that navigation was blocked or the route changed.
   */
  logout(event: Event): void {
    event.preventDefault();
    this.authService.logout();
    this.router.navigate([this.localize.translateRoute('/member/login')]);
  }

}
